Hearsay = require 'hearsay'

module.exports = (signal, delay) ->
  new Hearsay.ContinuousSignal (send) ->
    lastValue = signal.get()
    lastSend = Date.now()
    send(lastValue)

    nextUpdate = null

    sendNewValue = (latest) ->
      lastValue = latest
      lastSend = Date.now()
      send(latest)

    if delay > 0
      unsubscribe = signal.subscribe (latest) ->
        clearTimeout nextUpdate
        # don't send same value twice in a row
        if lastValue == latest
          return
        remainingWait = delay - (Date.now() - lastSend)
        if remainingWait <= 0
          sendNewValue latest
        else
          nextUpdate = setTimeout ->
            sendNewValue latest
          , remainingWait

      ->
        unsubscribe()
        clearTimeout nextUpdate

    else
      unsubscribe = signal.subscribe (latest) ->
        cancelAnimationFrame nextUpdate
        nextUpdate = requestAnimationFrame ->
          send(latest)

      ->
        unsubscribe()
        cancelAnimationFrame nextUpdate
